// const HeaderInLineStyle = {
// 	position: "absolute",
// 	overflow: "hidden",
// 	alignSelf: "center",
// 	display: "flex",
// 	backgroundColor: "white",
// 	flex: "0 0 5em",
// 	maxHeight: "50px",
// 	width: "100%",
// 	boxShadow: "0 3px 4px 0 rgba(0, 0, 0, 0.15), 0 -1px 4px 0 rgba(0, 0, 0, 0.15)",
// 	zIndex: "2"
// }

// const titleStyle = {
// 	flex: "1",
// 	display: "flex",
// 	height: "5em",
// 	lineHeight: "5em",
// 	order: "2",
// 	overflow: "hidden",
// 	textAlign: "center"
// }

// const logoStyle = {
// 	height: "2.5em",
// 	fontSize: "1.7rem",
// 	lineHeight: "1.7em"
// }

const Header = () => {
	return (
		<header className={"app-header"}>
			<div className="app-header-title">
				<span className="km-logo-header">
					<img className="km-logo-img" src="/images/km_logo_h_b.svg" alt="Kodak Moments Logo" />
				</span>
			</div>
		</header>
	)
}

export default Header;